
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Mumbaitohyderabadcabs() {



    const cardData =
    {
        keyword: ' Mumbai to Hyderabad Cab Service ',
        heading: 'Vedant Travels: Mumbai to Hyderabad Cab Service',
        headingDescription: 'Vedant Travels offers a reliable and comfortable Mumbai to Hyderabad cab service, ensuring a smooth and hassle-free journey for travelers. Whether you are traveling for business, visiting historical landmarks like the Charminar, or exploring Hyderabad’s famous biryani and shopping hubs, our well-maintained fleet of sedans, SUVs, and luxury cars caters to all travel needs. Our professional drivers ensure a safe and convenient trip with flexible pickup and drop-off options. With 24/7 availability, competitive fares, and an easy online booking system, Vedant Travels makes your Mumbai to Hyderabad journey stress-free and enjoyable.',

        top: 'Top Places to Visit in Hyderabad with Vedant Travels',

"topPlaces": [
    {
        "title": "Charminar",
        "description": "One of the most iconic landmarks in India, Charminar is a historic monument built in 1591 by Sultan Muhammad Quli Qutb Shah. The four grand minarets, intricate architecture, and surrounding bustling markets make it a must-visit destination in Hyderabad."
    },
    {
        "title": "Golconda Fort",
        "description": "A majestic fort known for its acoustic wonders and stunning architecture, Golconda Fort offers breathtaking views of the city. The fort is famous for its whispering walls and historical significance in the diamond trade, including the Kohinoor diamond."
    },
    {
        "title": "Ramoji Film City",
        "description": "Spread across 2,000 acres, Ramoji Film City is the world’s largest film studio complex and a major attraction in Hyderabad. Visitors can take guided tours to explore film sets, amusement parks, and live entertainment shows."
    },
    {
        "title": "Hussain Sagar Lake",
        "description": "Located between Hyderabad and Secunderabad, Hussain Sagar Lake is famous for its massive Buddha statue in the middle of the lake. Boating, laser shows, and evening strolls along the Necklace Road make it a perfect leisure spot."
    },
    {
        "title": "Chowmahalla Palace",
        "description": "A stunning example of Nizami architecture, Chowmahalla Palace was once the official residence of the Nizams of Hyderabad. The palace features grand halls, vintage cars, and an exquisite collection of antiques, offering a glimpse into the royal past."
    },
    {
        "title": "Salar Jung Museum",
        "description": "One of India’s largest museums, the Salar Jung Museum houses an incredible collection of art, artifacts, and antiques from around the world. Notable exhibits include the famous Veiled Rebecca statue, Mughal-era weapons, and European paintings."
    },
    {
        "title": "Birla Mandir",
        "description": "Perched atop Naubat Pahad hill, Birla Mandir is a beautiful white marble temple dedicated to Lord Venkateshwara. The temple offers stunning panoramic views of Hyderabad and is a peaceful retreat for devotees."
    },
    {
        "title": "Laad Bazaar",
        "description": "A paradise for shoppers, Laad Bazaar is a historic market near Charminar, famous for its colorful bangles, pearl jewelry, and bridal wear. It’s a must-visit place for those looking to buy authentic Hyderabadi souvenirs."
    },
    {
        "title": "Nehru Zoological Park",
        "description": "A great destination for families and wildlife lovers, Nehru Zoological Park is home to over 100 species of animals, including tigers, elephants, and exotic birds. The park offers safari rides and boating for visitors."
    },
    {
        "title": "Shilparamam",
        "description": "For a cultural experience, Shilparamam is a crafts village showcasing traditional handicrafts, folk dances, and rural arts. Visitors can buy handmade crafts and enjoy live cultural performances in an authentic village setting."
    }
],

"services": [
    {
      "name": "Mumbai to Hyderabad Cab Service by Vedant Travels",
      "description": "Traveling from Mumbai to Hyderabad? Vedant Travels offers reliable and comfortable cab services for your journey. Whether you're visiting Hyderabad for business or leisure, our well-maintained vehicles and professional drivers will ensure you have a smooth and enjoyable trip."
    },
    {
      "name": "Hyderabad Taxi from Mumbai",
      "description": "Looking for a taxi from Mumbai to Hyderabad? Vedant Travels offers efficient and affordable taxi services to Hyderabad, ensuring a comfortable and hassle-free journey. Whether you’re traveling solo or with a group, we have a fleet of vehicles to meet your needs."
    },
    {
      "name": "Mumbai to Hyderabad One Way Taxi",
      "description": "For a one-way trip from Mumbai to Hyderabad, choose Vedant Travels for a cost-effective and convenient taxi service. Our one-way taxi option is perfect for those who only need transportation to Hyderabad, providing a comfortable ride without the need for a return trip."
    },
    {
      "name": "Hyderabad Taxi Service from Mumbai",
      "description": "Vedant Travels provides premium Hyderabad taxi services from Mumbai, ensuring your journey is smooth and timely. Whether you need transportation for a business trip, sightseeing, or any other purpose, our fleet of vehicles is ready to cater to your needs."
    },
    {
      "name": "Mumbai to Hyderabad Car Hire",
      "description": "If you're looking to hire a car for your journey from Mumbai to Hyderabad, Vedant Travels offers a wide range of vehicles, including sedans, SUVs, and more. Our car hire services provide the flexibility and comfort you need for a relaxed journey."
    },
    {
      "name": "Mumbai to Hyderabad Innova",
      "description": "Traveling with family or a group? Book an Innova for your Mumbai to Hyderabad journey with Vedant Travels. The Innova offers spacious seating and comfort, making it the ideal choice for long-distance trips."
    },
    {
      "name": "Hyderabad Taxi Booking from Mumbai",
      "description": "Booking a taxi from Mumbai to Hyderabad is quick and easy with Vedant Travels. You can book your taxi online or by phone, ensuring a seamless and hassle-free process. We guarantee a safe and comfortable ride for every traveler."
    },
    {
      "name": "Mumbai to Hyderabad Cab Fare",
      "description": "At Vedant Travels, we provide competitive and transparent pricing for your journey from Mumbai to Hyderabad. Our taxi fares are designed to offer you the best value while ensuring you travel in comfort. Contact us for an accurate fare quote based on your trip."
    },
    {
      "name": "Mumbai to Hyderabad Round Trip",
      "description": "Planning a round trip from Mumbai to Hyderabad? Vedant Travels offers flexible round-trip taxi services, ensuring that you have a comfortable and reliable ride both ways. Our experienced drivers will make your journey smooth and enjoyable."
    }
  ],



  "tableData": [
    ["Mumbai to Hyderabad Cab", "Hyderabad Taxi from Mumbai"],
    ["Mumbai to Hyderabad One Way Taxi", "Hyderabad Taxi Service Mumbai"],
    ["Mumbai to Hyderabad Car Hire", "Mumbai to Hyderabad Innova"],
    ["Hyderabad Taxi Booking Mumbai", "Mumbai to Hyderabad Cab Fare"],
    ["Mumbai to Hyderabad Round Trip"]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we prioritize punctuality. Our professional drivers ensure that your Mumbai to Hyderabad journey is timely and hassle-free. Whether you're traveling for business or leisure, we guarantee a prompt and reliable service."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "Travel in comfort with our spacious and well-maintained vehicles, designed to offer you a relaxing ride. With ample legroom, air conditioning, and comfortable seating, your long-distance journey will be smooth and enjoyable."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our drivers are well-trained and experienced in handling long-distance routes like Mumbai to Hyderabad. They ensure a safe, efficient, and smooth ride, offering local knowledge and making the journey more pleasant for you."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Vedant Travels offers competitive pricing with no hidden charges. We provide clear, upfront pricing, ensuring great value for your money. Our transparent pricing system helps you avoid any surprises, ensuring a fair experience."
    },
    {
      "WhyChooseheading": "Safe and Secure Journey",
      "WhyChoosedescription": "Safety is our top priority. Our fleet is regularly maintained and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers strictly adhere to safety protocols to provide a secure and comfortable journey."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether it's an early morning departure or a late-night return, we’re available round the clock to serve you. Our customer service team is ready to assist you at any time, ensuring a seamless experience from start to finish."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking your Mumbai to Hyderabad cab with Vedant Travels is easy and hassle-free. You can book online through our website or mobile app, or you can contact our customer service team for assistance with your booking."
    },
    {
      "WhyChooseheading": "Customized Travel Packages",
      "WhyChoosedescription": "We offer flexible travel packages to cater to your specific needs. Whether you’re traveling for business, a family trip, or sightseeing, we tailor our services to fit your schedule and preferences."
    }
  ]
    }
    const faqData = [
        {
            id: 1,
            question: 'How can I book a Mumbai to Hyderabad cab with Vedant Travels?',
            answer: 'You can book your cab online through our website or mobile app. Alternatively, you can contact our customer service team, who will assist you with your booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for the Mumbai to Hyderabad trip?',
            answer: 'We offer a wide range of well-maintained vehicles, including sedans, SUVs, and luxury cars. All vehicles are designed for comfort and safety, ensuring a pleasant and smooth journey.',
        },
        {
            id: 3,
            question: 'Are the drivers experienced for long-distance travel?',
            answer: 'Yes, our drivers are trained and experienced in handling long-distance trips. They are knowledgeable about the best routes and follow safe driving practices, ensuring a smooth and timely ride.',
        },
        {
            id: 4,
            question: 'How do I pay for my Mumbai to Hyderabad cab rental?',
            answer: 'We accept various payment methods, including cash, credit/debit cards, and online payments through our app, making payment easy and convenient.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip cab for Mumbai to Hyderabad?',
            answer: 'Yes, you can book a round-trip cab. Simply provide your return details during the booking process, and we’ll take care of the rest.',
        },
        {
            id: 6,
            question: 'Are there any extra charges for waiting or detours during the Mumbai to Hyderabad trip?',
            answer: 'Any additional charges for waiting time or detours will be communicated to you upfront. We believe in complete transparency, so you’ll never encounter hidden costs.',
        },
        {
            id: 7,
            question: 'Can I hire a cab for sightseeing in Hyderabad?',
            answer: 'Yes, we offer sightseeing tours in Hyderabad. Visit famous landmarks like the Charminar, Golconda Fort, Hussain Sagar Lake, and more with a trusted driver.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a Mumbai to Hyderabad cab?',
            answer: 'Our vehicles are designed to accommodate standard luggage. If you have extra or specialized luggage, please inform us at the time of booking, and we’ll make the necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is Vedant Travels available for corporate travel to Hyderabad?',
            answer: 'Yes, we offer corporate travel services for business trips to Hyderabad. Whether it’s for meetings, conferences, or other professional events, we ensure your travel is comfortable and timely.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for Mumbai to Hyderabad travel?',
            answer: 'Vedant Travels provides reliable, comfortable, and affordable cab services for your Mumbai to Hyderabad trip. With professional drivers, well-maintained vehicles, and transparent pricing, we ensure your journey is safe, smooth, and hassle-free.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Ravi Sharma",
            title: "Customer",
            quote: "I traveled from Mumbai to Hyderabad with Vedant Travels, and it was a fantastic experience. The driver was professional, the car was comfortable, and I reached my destination on time. Highly recommend!",
            rating: 5,
        },
        {
            name: "Mrs. Anjali Mehta",
            title: "Customer",
            quote: "Our family trip from Mumbai to Hyderabad with Vedant Travels was wonderful. The vehicle was clean, spacious, and the driver was friendly and knowledgeable about the route. We’ll definitely use their service for future trips.",
            rating: 5,
        },
    ];
    
    
    
    
    
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    
      
   

const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Hyderabad Cab",
  "image": "https://vedanttravels.in/assets/images/mumbai-to-hyderabad-cab.jpg",
  "description": "Book Mumbai to Hyderabad cab with Vedant Travels for a safe and comfortable journey. Choose from AC sedans, SUVs, and tempo travellers for one-way and round trips between these two major cities.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "3200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "8999",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/mumbai-to-hyderabad-cab"
  }
};


  


    return (
        <div>
            <Helmet>
  <title>Mumbai to Hyderabad Cab | Safe & Comfortable Travel | Vedant Travels</title>
  <meta 
    name="description" 
    content="Book Mumbai to Hyderabad cab with Vedant Travels for a safe and comfortable journey. Choose from AC sedans, SUVs, and tempo travellers for one-way and round trips between these two major cities." 
  />
  <meta 
    name="keywords" 
    content="Mumbai to Hyderabad Cab, Hyderabad Taxi from Mumbai, Vedant Travels Mumbai Hyderabad, AC Cab Mumbai Hyderabad, SUV Cab Mumbai Hyderabad, Outstation Cab Mumbai Hyderabad" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

  
           
            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/94.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Mumbaitohyderabadcabs;